// React imports.
import React, { Component } from "react";

// App imports.


const SelectStateAndYear = ({ state }) => (
    <div >
        {state.selectedAssessmentTypeToCreate == "1"
            &&
            <React.Fragment>
                <p><strong>ASSESMENT #1 – Defining Data Requirements:</strong></p>
                <p>
                    Assessment #1 is designed to help you assess the reliability of your electric baseload expenditures data collected in Section V of the LIHEAP Performance Measures Form.
                </p>
                <p>
                    Throughout the assessment you will be asked to provide ideas that will later be included in your Data Reliability Action Plan. To be clear, these plans will be for your own internal use only. These Action Plans WILL NOT constitute a change or addendum to your State Plan, and OCS WILL NOT hold you to the action items included within them.
                </p>
                <p>
                To begin, select 
                {state.viewAll === true &&
                    <span >your state and</span>  
                }
                &nbsp;the year you would like to assess below.
                </p>

            </React.Fragment>
        }
        {state.selectedAssessmentTypeToCreate == "2a"
        &&
            <React.Fragment>
                <p><strong>ASSESMENT #2A – Data Collection – Vendors:</strong></p>
                <p>
                    Assessment #2A helps you determine whether you are requesting and collecting data
                    from at least the minimum required number of electric vendors in your
                    state/territory. If you are not requesting or collecting data from the
                    minimum required number of vendors, you may have a data reliability issue
                    and the tool will ask you a series of questions to determine what that
                    issue may be. 
                </p>
                <p>
                    Throughout the assessment you will be asked to provide ideas that will later be included
                    in your Data Reliability Action Plan. To be clear, these plans will be for your own
                    internal use only. These Action Plans WILL NOT constitute a change or addendum to your
                    State Plan, and OCS WILL NOT hold you to the action items included within them. 
                </p>
                <p>
                To begin, select 
                {state.viewAll === true &&
                    <span >your state and</span>  
                }
                &nbsp;the year you would like to assess below.
                </p>
            </React.Fragment>
        }
        {state.selectedAssessmentTypeToCreate == "2b"
        &&
            <React.Fragment>
                <p><strong>ASSESMENT #2B – Data Collection – Households:</strong></p>
                <p>
                    Assessment #2B helps you determine whether you are receiving electric bill data from 
                    enough households to be representative of the larger population of LIHEAP assisted
                    households that heat their homes with each main heating fuel.  If you are not receiving
                    electric baseload data from at least 50% of the electric heat and natural gas households
                    you serve, and at least 20% of the fuel oil and propane households you serve,  you may
                    have a data reliability issue and the tool will ask you a series of questions to determine
                    what that issue may be. 
                </p>
                <p>
                    Throughout the assessment you will be asked to provide ideas that will later be included
                    in your Data Reliability Action Plan. To be clear, these plans will be for your own
                    internal use only. These Action Plans WILL NOT constitute a change or addendum to your
                    State Plan, and OCS WILL NOT hold you to the action items included within them. 
                </p>
                <p>
                To begin, select 
                {state.viewAll === true &&
                    <span >your state and</span>  
                }
                &nbsp;the year you would like to assess below.
                </p>
            </React.Fragment>
        }
        {state.selectedAssessmentTypeToCreate == "3a"
            &&
            <React.Fragment>
                <p><strong>ASSESMENT #3A – Data Recording &amp; Processing – Vendor Assignment:</strong></p>
                <p>
                    Assessment #3A helps you determine whether you were able to get enough of your assisted
                    households to list their electric vendor on their application.
                </p>
                <p>
                    To begin, select 
                    {state.viewAll === true &&
                        <span >your state and</span>  
                    }
                    &nbsp;the year you would like to assess below. If you select a past year for which you
                    submitted a PM Data Form, certain fields in this tool may auto-populate from the
                    LIHEAP Data Warehouse. If you would like to conduct a reliability check on your
                    FY data which is currently being reported and processed, you will be given
                    the opportunity to manually fill in the fields using your current FY PM Data Form.
                </p>
            </React.Fragment>
        }
        {state.selectedAssessmentTypeToCreate == "3b"
            &&
            <React.Fragment>
                <p><strong>ASSESMENT #3B – Data Recording &amp; Processing – Account Matching:</strong></p>
                <p>
                    Assessment #3B helps you determine whether you were able to collect 12 months  
                    of consecutive billing data for both main heating fuel expenditures and  
                    electric baseload expenditures for a sufficient number of households. If  
                    you were not able to collect enough data on both, the tool tries to help  
                    you determine whether you simply did not collect enough billing data or  
                    whether you have an account matching issue.
                </p>
                <p>
                    To begin, select 
                    {state.viewAll === true &&
                        <span >your state and</span>  
                    }
                    &nbsp;the year you would like to assess below.
                    If you select a past year for which you submitted a PM Data Form, certain  
                    fields in this tool may auto-populate from the LIHEAP Data Warehouse. If  
                    you would like to conduct a reliability check on data which  is currently
                    being reported and processed, you will be given the opportunity   
                    to manually fill in the fields using your current FY PM Data Form.

                </p>
            </React.Fragment>
        }
        {state.selectedAssessmentTypeToCreate == "4"
            &&
            <React.Fragment>
                <p><strong>ASSESMENT #4 – Data Checking Routines:</strong></p>
                <p>
                    Assessment #4 helps you determine whether the data checking routines  
                    you have built into your system are robust enough to help ensure  
                    data reliability. The more thoroughly your data is checked, the  
                    more confident you can be about the level of reliability it provides.
                </p>
                <p>
                    This Assessment consists of several Yes or No Questions. Depending  
                    on your answers, the tool will prompt you to provide ideas to  
                    address potential gaps in your checking routines. These ideas  
                    will later be included in your Data Reliability Action Plan.  
                    To be clear, these plans will be for your own internal use  
                    only. These Action Plans WILL NOT constitute a change or  
                    addendum to your State Plan, and OCS WILL NOT hold you to  
                    the action items included within them. 
                </p>
            </React.Fragment>
        }



        {state.selectedAssessmentTypeToCreate == "oa"
            &&
            <React.Fragment>
                <p><strong>INSTRUCTIONS FOR THE OVERALL ASSESSMENT:</strong></p>
                <p>
                    The Overall Reliability Assessment is the starting place for using the Electric Baseload Tool.  It includes the primary assessment checks for each step of the data reliability framework.  For each of these primary assessment checks, you will be asked to enter specific information from your most recent performance measures data.  Once you enter the requested information, this tool will let you know which in-depth assessments you will want to complete for a further investigation of your data. 
                </p>
                <p>
                    To begin, select the year you would like to assess below. If you select a past year for which you submitted a PM Data Form, certain fields in this tool may auto-populate from the LIHEAP Data Warehouse. If you would like to conduct a reliability check on your FY data which is currently being reported and processed, you will be given the opportunity to manually fill in the fields using your current FY PM Data Form.
                </p>
            </React.Fragment>
        }

        Choose your state and year
        <br/><br/>
        {state.UserInfo.viewAll === true &&
            <label>
                Select your state:
                <select className="form-control" style={{height:25,width:"15%"}} id="SelectedGranteeId" value={state.SelectedGranteeId || ''} onChange={state.SelectStateAndYearFieldChangeHandler}>
                        <option >Choose a state</option>
                        {state.Grantees.map(grantee => {
                        return (
                            <option key={grantee.granteeId}  value={grantee.granteeId}>{grantee.granteeName}</option>
                        );
                    })}
                </select>
            </label>
        }
        {state.UserInfo.viewAll != true &&
            <div>Your state: <strong>{state.UserInfo.granteeName}</strong></div>
        }
        {state.SelectedGranteeName != null &&
            <div>Selected state: <strong>{state.SelectedGranteeName}</strong></div>
        }
        <br/>
        Select your year:
        <select className="form-control" style={{height:25,width:"15%"}} id="SelectedYear" value={state.SelectedYear || ''} onChange={state.SelectStateAndYearFieldChangeHandler}>
            <option >Choose a year</option>
            {state.FiscalYears.map(year => {
                return (
                    <option key={year.fiscalYear} value={year.fiscalYear}>{year.fiscalYear}</option>
                );
            })}
        </select>

        <span className="errorMessageText">{state.CreateAssessmentErrorMessage}</span>

        <br /><br />
        <button className="dataButton"
          onClick={() => state.SelectStateAndYearShowPreviousStep()}>
          Previous
        </button>
        <button className="dataButton"
          onClick={() => state.SelectStateAndYearShowNextStep()}
          disabled={state.SelectedGranteeId=== null || state.SelectedGranteeId === 'Choose a state' || state.SelectedYear === 'Choose a year'  || state.SelectedYear === null}>
          Next
        </button>



    </div>
);

export default SelectStateAndYear;
